/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useEffect, useRef } from 'react';

export const useIsMounted = () => {
    const isMounted = useRef(false);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
